module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("tHmG9"))).then(() => parcelRequire('fThBo'));